import { render, staticRenderFns } from "./ResetPasswordView.vue?vue&type=template&id=7c2e05c9&scoped=true&"
import script from "./ResetPasswordView.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordView.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordView.vue?vue&type=style&index=0&id=7c2e05c9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2e05c9",
  null
  
)

export default component.exports